import React, { useCallback, useState } from 'react';
import { useOrderContext } from '@/modules/order/context/OrderContext.tsx';
import { ProductTemplateSelection } from '@/shared/components/PresetSelection/ProductTemplateSelection.tsx';
import { ProductTemplateSelectedOption } from '@/shared/components/PresetSelection/types.ts';
import { UnifiedAutomaticOrderProductSelection } from '@/modules/order/components/ProductSelection/UnifiedAutomaticOrderProductSelection.tsx';
import { ManualOrderProductSelection } from '@/modules/order/components/ProductSelection/ManualOrderProductSelection.tsx';

export function OrderProductSelection({ onContinue }: { onContinue: () => void }) {
    const { processingType, setProcessingType, contextData } = useOrderContext();

    const formData = contextData.getFormData();
    const businessCase = contextData.getBusinessCase();

    const [needsTemplateSelection, setNeedsTemplateSelection] = useState<boolean>(
        !businessCase && !formData.productType
    );

    const handleTemplateSelect = useCallback(
        ({ productType, isStandalone, pricingStrategy, formPreset }: ProductTemplateSelectedOption) => {
            if (pricingStrategy) {
                contextData.setBusinessCase({ productType, pricingStrategy, isStandalone }, formPreset);
            } else {
                contextData.setFormData({ productType, isStandalone, ...formPreset });
            }
            setNeedsTemplateSelection(false);
        },
        [contextData]
    );

    const handleClearSelection = useCallback(() => {
        contextData.setBusinessCase(undefined);
        setNeedsTemplateSelection(true);
    }, [contextData]);

    if (needsTemplateSelection) {
        return (
            <ProductTemplateSelection
                processingType={processingType}
                onChangeProcessingType={setProcessingType}
                onSelect={handleTemplateSelect}
            />
        );
    }

    if (processingType === 'AUTOMATIC') {
        return (
            <UnifiedAutomaticOrderProductSelection onContinue={onContinue} onClearSelection={handleClearSelection} />
        );
    } else {
        return <ManualOrderProductSelection onContinue={onContinue} onClearSelection={handleClearSelection} />;
    }
}
